import {
  LayerModelDc,
  LayerTemplateModelDc,
  LegendTemplateModelDc,
  PrintTaskParametersDc,
  Vector2,
} from "@evergis/api";
import { Color } from "@evergis/color";
import { RangeValue } from "@evergis/ui";

import { LayerInfo } from "./resourceInfo";

export type TemplateModel = LayerTemplateModelDc | LegendTemplateModelDc;
export type PrintTaskInput = Override<PrintTaskParametersDc, "templates", TemplateModel[]>;

export type PrintResult = {
  image: Blob;
  name: string;
  format: string;
};

export enum PrintType {
  Map = "map",
  MapWithLegend = "mapWithLegend",
  MapAndLegend = "mapAndLegend",
}

export enum Position {
  Left = "left",
  Top = "top",
  Right = "right",
  Bottom = "bottom",
}

export type GridSetting = {
  size?: number;
  color?: Color;
};

export enum LegendPosition {
  Left = "left",
  Right = "right",
  Under = "bottom",
  Vertical = "vertical",
  Horizontal = "horizontal",
}

export type LegendSetting = {
  placement?: PrintType;
  position?: LegendPosition;
};

export type PrintSettings = {
  title?: string;
  withScale?: boolean;
  grid?: GridSetting | null;
  legend?: LegendSetting | null;
};

export type PrintRectangle = {
  [Position.Left]?: number;
  [Position.Top]?: number;
  [Position.Right]?: number;
  [Position.Bottom]?: number;
  height?: number;
  width?: number;
};

export type PrintFile = {
  name: string;
  ext: string;
};

export enum PrintTemplateName {
  Default = "default.cshtml",
  Map = "map.cshtml",
  MapLegendLeft = "mapLegendLeft.cshtml",
  MapLegendRight = "mapLegendRight.cshtml",
  MapLegendBottom = "mapLegendBottom.cshtml",
  LegendVertical = "legendVertical.cshtml",
  LegendHorizontal = "legendHorizontal.cshtml",
}

export enum PrintTemplateType {
  Map = "layerTemplateModel",
  Legend = "legendLayerTemplateModel",
}

export type PrintLayer = LayerModelDc & LayerInfo;

export type PrintInfo = {
  layers?: PrintLayer[];
  baseMapName?: string;
  mapCenter?: Vector2;
  srid?: number;
  resolution?: number;
  rectangle?: PrintRectangle;
  printFile: PrintFile;
  settings: PrintSettings;
  title?: string;
  defaultScaleRange?: RangeValue;
};

export enum Margin {
  Top,
  Right,
  Bottom,
  Left,
}

export type MarginType = [number, number, number, number];
